import styled from 'styled-components';
import {
  mdPaddingX,
} from '/imports/ui/stylesheets/styled-components/general';
import { colorBlue, colorPrimary, colorWhite } from '/imports/ui/stylesheets/styled-components/palette';
import { smallOnly } from '/imports/ui/stylesheets/styled-components/breakpoints';
import CommonHeader from '/imports/ui/components/common/control-header/component';

const Notes = styled.div<{ isChrome: boolean }>`
  background-color: ${colorWhite};
  padding: ${mdPaddingX};
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  overflow: hidden;
  height: 100%;

  ${({ isChrome }) => isChrome && `
    transform: translateZ(0);
  `}

  @media ${smallOnly} {
    transform: none !important;
    &.no-padding {
      padding: 0;
    }
  }
`;

const Header = styled(CommonHeader)`
  padding-bottom: .2rem;
  button{
    padding: 4px!important;
    background : ${colorPrimary};
    border-radius : 4px;
    i::before {
      color: ${colorWhite} !important;
    }
  }
`;

export default {
  Notes,
  Header,
};
